var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('n-loading-bar',{attrs:{"loading":_vm.loading}}),_c('h1',[_vm._v("AI小助手")]),_c('div',{staticClass:"box",on:{"click":_vm.onAIClick}},[_c('div',{staticClass:"box-bg"}),_c('div',{staticClass:"box-content"},[_vm._v("立即开始")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }